import * as Models from "./";

export interface IUserModel {
  userId: string;
  displayName: string;
  username: string;
  emailAddress: string;
  suspendWorkIssueNotification: boolean;
  comment: string;
  isApproved: boolean;
  isLocked: boolean;
  isBrokerAgent: boolean;
  windowsUsername: string;
  agentCode: string;
  solicitorNumber: string;
  partner: Models.PartnerModel.PartnerModel;
  roles: Array<Models.RoleModel.IRoleModel>;
  groups: Array<Models.GroupModel.GroupModel>;
}

export class UserModel implements IUserModel {
  userId: string;
  displayName: string;
  username: string;
  emailAddress: string;
  suspendWorkIssueNotification = false;
  comment: string;
  isApproved: boolean;
  isLocked: boolean;
  isBrokerAgent: boolean;
  windowsUsername: string;
  agentCode: string;
  solicitorNumber: string;
  partner: Models.PartnerModel.PartnerModel;
  roles: Array<Models.RoleModel.IRoleModel> = new Array<Models.RoleModel.IRoleModel>();
  groups: Array<Models.GroupModel.GroupModel> = new Array<Models.GroupModel.GroupModel>();
}
